import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/content";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] lg:h-[700px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20elegant%20stylized%20background%20of%20soft%20draped%20fabric%20folds%20in%20deep%20navy%20blue%20and%20warm%20gold%20tones%2C%20flowing%20silky%20texture%2C%20artistic%20minimal%20composition%2C%20luxurious%20calm%20atmosphere%2C%20cinematic%20soft%20lighting%2C%20high%20detail&width=1920&height=1080&seq=brand-hero-main&orientation=landscape"
        alt="白峰美羽品牌主视觉"
        title="白峰美羽品牌官网 - 以美为峰，以羽为翼"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/60 via-primary-950/45 to-primary-950/70"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/50 to-transparent"></div>

      <div className="relative w-full h-full max-w-site mx-auto px-4 md:px-6 flex flex-col justify-center">
        <div className="max-w-2xl animate-softfade">
          <p className="text-accent-300 text-xs md:text-sm tracking-[0.4em] uppercase mb-5">
            {siteInfo.nameEn}
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-background-50 leading-tight">
            以美为峰
            <br />
            以羽为翼
          </h1>
          <p className="mt-6 text-sm md:text-base text-background-200 leading-relaxed max-w-xl">
            白峰美羽以东方审美为根、以现代工艺为翼，为注重品质与文化的你，打造兼具质感与温度的精品。
            从一间工作室到一座品牌美学中心，十六年来我们只认真对待一件事——把细节做到值得长久使用。
          </p>
          <div className="mt-9 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4">
            <Link
              to="/brand"
              className="inline-flex justify-center items-center px-7 py-3 rounded-md bg-accent-500 text-accent-950 text-sm font-medium hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解品牌故事
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/news"
              className="inline-flex justify-center items-center px-7 py-3 rounded-md border border-background-50/40 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看最新动态
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 md:bottom-8 inset-x-0 flex justify-center">
        <span className="flex flex-col items-center gap-1 text-background-200/80 text-[11px] tracking-widest">
          向下探索
          <i className="ri-arrow-down-line animate-bounce"></i>
        </span>
      </div>
    </section>
  );
}